export const companySalesTeamTranslation = {
  title: 'company_sales_team-title',
  emptySalesTeamContent: 'company_sales_team-empty_sales_team_content',
  leadPBM: 'company_sales_team-lead_pbm',
  email: 'company_sales_team-email',
  msTeamChat: 'company_sales_team-ms_team_chat',
  msTeamCall: 'company_sales_team-ms_team_call',
  name: 'company_sales_team-name',
  role: 'company_sales_team-role',
  bUnit: 'company_sales_team-bUnit',
  assignmentPeriod: 'company_sales_team-assignmentPeriod',
}

export const salesTeamRequestTranslation = {
  noValue: 'jbp-financial-cockpit-sales-team-no-value',
  loading: 'jbp-financial-cockpit-sales-team-loading',
  requestsLoadError: 'jbp-financial-cockpit-sales-team-requests-load-error',
  loadError: 'jbp-financial-cockpit-sales-team-load-error',
  saveError: 'jbp-financial-cockpit-sales-team-save-error',
  saving: 'jbp-financial-cockpit-sales-team-saving',
  close: 'jbp-financial-cockpit-sales-team-close',
  person: 'jbp-financial-cockpit-sales-team-person',
  people: 'jbp-financial-cockpit-sales-team-people',
  openRequests: 'jbp-financial-cockpit-sales-team-open-requests',
  editRequest: 'jbp-financial-cockpit-sales-team-edit-request',
  viewRequest: 'jbp-financial-cockpit-sales-team-view-request',
  changeContact: 'jbp-financial-cockpit-sales-team-change-contact',
  removeContact: 'jbp-financial-cockpit-sales-team-remove-contact',
  deleteRequest: 'jbp-financial-cockpit-sales-team-delete-request',
  addContact: 'jbp-financial-cockpit-sales-team-add-contact',
  contactActions: 'jbp-financial-cockpit-sales-team-contact-actions',
  collapse: 'jbp-financial-cockpit-sales-team-collapse',
  expand: 'jbp-financial-cockpit-sales-team-expand',
  retry: 'jbp-financial-cockpit-sales-team-retry',
  previousContact: 'jbp-financial-cockpit-sales-team-previous-contact',
  previousPage: 'jbp-financial-cockpit-sales-team-previous-page',
  nextPage: 'jbp-financial-cockpit-sales-team-next-page',
  nextContact: 'jbp-financial-cockpit-sales-team-next-contact',
  of: 'jbp-financial-cockpit-sales-team-of',
  page: 'jbp-financial-cockpit-sales-team-page',
  allRoles: 'jbp-financial-cockpit-sales-team-all-roles',
  filterRole: 'jbp-financial-cockpit-sales-team-filter-role',
  emptyRole: 'jbp-financial-cockpit-sales-team-empty-role',
}

export const getSalesTeamRequestActionKey = (action: string) =>
  `jbp-financial-cockpit-sales-team-request-action-${(action || 'contact').toLowerCase()}`
